export default {
    setUserData(state, payload){
        state.userData = payload.userData;
    },
    setLogos(state, payload){
        state.logos = payload;
    }
};